var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-box",
    {
      staticClass: "flex-1",
      attrs: { title: _vm.$t("others.title"), hasPadding: "" },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function () {
            return [
              _vm.showTooltip
                ? _c(
                    "jade-tooltip",
                    {
                      attrs: {
                        text: _vm.computedTooltip,
                        placement: "top-start",
                      },
                    },
                    [
                      _c("jade-icon", {
                        attrs: { use: "circle-info", size: "small" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col gap-2" },
          [
            _c("jade-text", { attrs: { variant: "heading-small" } }, [
              _vm._v("R$ " + _vm._s(_vm.data.value)),
            ]),
            _c(
              "div",
              [
                _c("jade-text", [_vm._v(_vm._s(_vm.computedText.label))]),
                _c("jade-text", [_vm._v(_vm._s(_vm.computedText.percentage))]),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }